import { render } from "./Sidebar.vue?vue&type=template&id=22944954&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=22944954&lang=scss&scoped=true"

import exportComponent from "/var/www/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22944954"]])

export default __exports__